// src/utils/anim.ts
// Time & distance coercion + attr assignment.

export function seconds(v: unknown, fallback = 0): number {
  if (v == null || v === "") return fallback;
  if (typeof v === "number" && Number.isFinite(v)) return v;
  const s = String(v).trim().toLowerCase();
  if (/^\d+(\.\d+)?ms$/.test(s)) return parseFloat(s) / 1000;
  if (/^\d+(\.\d+)?s$/.test(s)) return parseFloat(s);
  const n = Number(s);
  return Number.isFinite(n) ? n : fallback;
}

/** Parse "24", "24px", "12.5" → number of pixels; returns fallback/undefined if invalid. */
export function pixels(v: unknown, fallback?: number): number | undefined {
  if (v == null || v === "") return fallback;
  if (typeof v === "number" && Number.isFinite(v)) return v;
  const s = String(v).trim().toLowerCase();
  if (/^\d+(\.\d+)?px$/.test(s)) return parseFloat(s);
  const n = Number(s);
  return Number.isFinite(n) ? n : fallback;
}

/** Return a CSS-ready size: "24" -> "24px", "50%" -> "50%", "1.5rem" -> "1.5rem". */
export function asPx(v: unknown): string | undefined {
  if (v == null || v === "") return undefined;
  if (typeof v === "number" && Number.isFinite(v)) return `${Math.round(v)}px`;
  const s = String(v).trim();
  if (/^\d+(\.\d+)?(px)?$/.test(s)) return s.endsWith("px") ? s : `${s}px`;
  if (/^\d+(\.\d+)?%$/.test(s)) return s;
  return s;
}

/** Apply animation-related data attributes expected by the animator. */
export function applyAnimAttrs(
  el: HTMLElement,
  opts: { anim?: string; delaySec?: number; durSec?: number; distPx?: number }
): void {
  if (!el) return;
  const { anim, delaySec, durSec, distPx } = opts || {};
  if (anim) el.setAttribute("data-anim", String(anim));
  if (Number.isFinite(delaySec as number) && (delaySec as number) >= 0)
    el.setAttribute("data-anim-delay", String(delaySec));
  if (Number.isFinite(durSec as number))
    el.setAttribute("data-anim-dur", String(durSec));
  if (Number.isFinite(distPx as number))
    el.setAttribute("data-anim-dist", String(distPx));
}